import React, { Component } from "react";
import { Route } from "react-router-dom";
import Course from "../Course/Course";
import FrontTest from "../FrontTest/FrontTest";
import StudentProfile from "./StudentProfile";

export default class StudentRoute extends Component {
  render() {
    return (
      <React.Fragment>
        <Route
          render={(props) => <StudentProfile {...props} />}
          path="/account/my-profile"
        />
      </React.Fragment>
    );
  }
}
